/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Error, ErrorResponse } from "./base";
import { User } from "./user";

export const protobufPackage = "traverse";

export interface TOTPRequest {
  token: string;
  userTotpToken: string;
}

export interface TOTPRegistrationRequest {
  token: string;
}

export interface TOTPRegistrationResponse {
  error: Error | undefined;
  qrPngBytes: string;
}

export interface IntakeRequest {
  newUser: User | undefined;
  password: string;
  referralCode: string;
  testOption: IntakeRequest_TestOption;
}

export enum IntakeRequest_TestOption {
  DIY = 0,
  NURSE = 1,
  OTHER = 2,
  UNRECOGNIZED = -1,
}

export function intakeRequest_TestOptionFromJSON(
  object: any
): IntakeRequest_TestOption {
  switch (object) {
    case 0:
    case "DIY":
      return IntakeRequest_TestOption.DIY;
    case 1:
    case "NURSE":
      return IntakeRequest_TestOption.NURSE;
    case 2:
    case "OTHER":
      return IntakeRequest_TestOption.OTHER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IntakeRequest_TestOption.UNRECOGNIZED;
  }
}

export function intakeRequest_TestOptionToJSON(
  object: IntakeRequest_TestOption
): string {
  switch (object) {
    case IntakeRequest_TestOption.DIY:
      return "DIY";
    case IntakeRequest_TestOption.NURSE:
      return "NURSE";
    case IntakeRequest_TestOption.OTHER:
      return "OTHER";
    default:
      return "UNKNOWN";
  }
}

export interface LoginRequest {
  email: string;
  password: string;
  totpCode: string;
}

export interface LoginResponse {
  error: Error | undefined;
  token: string;
  user: User | undefined;
}

export interface VerificationRequest {
  token: string;
}

export interface PasswordResetRequest {
  email: string;
  token: string;
  newPassword: string;
}

export interface CompleteUserRegistrationRequest {
  inviteToken: string;
  /** Collecting name & phone number from the user account */
  newUser: User | undefined;
  password: string;
}

export interface InviteTesterRequest {
  token: string;
  email: string;
}

const baseTOTPRequest: object = { token: "", userTotpToken: "" };

export const TOTPRequest = {
  encode(
    message: TOTPRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    if (message.userTotpToken !== "") {
      writer.uint32(18).string(message.userTotpToken);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TOTPRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseTOTPRequest } as TOTPRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.token = reader.string();
          break;
        case 2:
          message.userTotpToken = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TOTPRequest {
    const message = { ...baseTOTPRequest } as TOTPRequest;
    message.token =
      object.token !== undefined && object.token !== null
        ? String(object.token)
        : "";
    message.userTotpToken =
      object.userTotpToken !== undefined && object.userTotpToken !== null
        ? String(object.userTotpToken)
        : "";
    return message;
  },

  toJSON(message: TOTPRequest): unknown {
    const obj: any = {};
    message.token !== undefined && (obj.token = message.token);
    message.userTotpToken !== undefined &&
      (obj.userTotpToken = message.userTotpToken);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<TOTPRequest>, I>>(
    object: I
  ): TOTPRequest {
    const message = { ...baseTOTPRequest } as TOTPRequest;
    message.token = object.token ?? "";
    message.userTotpToken = object.userTotpToken ?? "";
    return message;
  },
};

const baseTOTPRegistrationRequest: object = { token: "" };

export const TOTPRegistrationRequest = {
  encode(
    message: TOTPRegistrationRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): TOTPRegistrationRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseTOTPRegistrationRequest,
    } as TOTPRegistrationRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.token = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TOTPRegistrationRequest {
    const message = {
      ...baseTOTPRegistrationRequest,
    } as TOTPRegistrationRequest;
    message.token =
      object.token !== undefined && object.token !== null
        ? String(object.token)
        : "";
    return message;
  },

  toJSON(message: TOTPRegistrationRequest): unknown {
    const obj: any = {};
    message.token !== undefined && (obj.token = message.token);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<TOTPRegistrationRequest>, I>>(
    object: I
  ): TOTPRegistrationRequest {
    const message = {
      ...baseTOTPRegistrationRequest,
    } as TOTPRegistrationRequest;
    message.token = object.token ?? "";
    return message;
  },
};

const baseTOTPRegistrationResponse: object = { qrPngBytes: "" };

export const TOTPRegistrationResponse = {
  encode(
    message: TOTPRegistrationResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(10).fork()).ldelim();
    }
    if (message.qrPngBytes !== "") {
      writer.uint32(18).string(message.qrPngBytes);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): TOTPRegistrationResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseTOTPRegistrationResponse,
    } as TOTPRegistrationResponse;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.error = Error.decode(reader, reader.uint32());
          break;
        case 2:
          message.qrPngBytes = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TOTPRegistrationResponse {
    const message = {
      ...baseTOTPRegistrationResponse,
    } as TOTPRegistrationResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromJSON(object.error)
        : undefined;
    message.qrPngBytes =
      object.qrPngBytes !== undefined && object.qrPngBytes !== null
        ? String(object.qrPngBytes)
        : "";
    return message;
  },

  toJSON(message: TOTPRegistrationResponse): unknown {
    const obj: any = {};
    message.error !== undefined &&
      (obj.error = message.error ? Error.toJSON(message.error) : undefined);
    message.qrPngBytes !== undefined && (obj.qrPngBytes = message.qrPngBytes);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<TOTPRegistrationResponse>, I>>(
    object: I
  ): TOTPRegistrationResponse {
    const message = {
      ...baseTOTPRegistrationResponse,
    } as TOTPRegistrationResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromPartial(object.error)
        : undefined;
    message.qrPngBytes = object.qrPngBytes ?? "";
    return message;
  },
};

const baseIntakeRequest: object = {
  password: "",
  referralCode: "",
  testOption: 0,
};

export const IntakeRequest = {
  encode(
    message: IntakeRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.newUser !== undefined) {
      User.encode(message.newUser, writer.uint32(10).fork()).ldelim();
    }
    if (message.password !== "") {
      writer.uint32(18).string(message.password);
    }
    if (message.referralCode !== "") {
      writer.uint32(34).string(message.referralCode);
    }
    if (message.testOption !== 0) {
      writer.uint32(24).int32(message.testOption);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IntakeRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseIntakeRequest } as IntakeRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.newUser = User.decode(reader, reader.uint32());
          break;
        case 2:
          message.password = reader.string();
          break;
        case 4:
          message.referralCode = reader.string();
          break;
        case 3:
          message.testOption = reader.int32() as any;
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): IntakeRequest {
    const message = { ...baseIntakeRequest } as IntakeRequest;
    message.newUser =
      object.newUser !== undefined && object.newUser !== null
        ? User.fromJSON(object.newUser)
        : undefined;
    message.password =
      object.password !== undefined && object.password !== null
        ? String(object.password)
        : "";
    message.referralCode =
      object.referralCode !== undefined && object.referralCode !== null
        ? String(object.referralCode)
        : "";
    message.testOption =
      object.testOption !== undefined && object.testOption !== null
        ? intakeRequest_TestOptionFromJSON(object.testOption)
        : 0;
    return message;
  },

  toJSON(message: IntakeRequest): unknown {
    const obj: any = {};
    message.newUser !== undefined &&
      (obj.newUser = message.newUser
        ? User.toJSON(message.newUser)
        : undefined);
    message.password !== undefined && (obj.password = message.password);
    message.referralCode !== undefined &&
      (obj.referralCode = message.referralCode);
    message.testOption !== undefined &&
      (obj.testOption = intakeRequest_TestOptionToJSON(message.testOption));
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<IntakeRequest>, I>>(
    object: I
  ): IntakeRequest {
    const message = { ...baseIntakeRequest } as IntakeRequest;
    message.newUser =
      object.newUser !== undefined && object.newUser !== null
        ? User.fromPartial(object.newUser)
        : undefined;
    message.password = object.password ?? "";
    message.referralCode = object.referralCode ?? "";
    message.testOption = object.testOption ?? 0;
    return message;
  },
};

const baseLoginRequest: object = { email: "", password: "", totpCode: "" };

export const LoginRequest = {
  encode(
    message: LoginRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    if (message.password !== "") {
      writer.uint32(18).string(message.password);
    }
    if (message.totpCode !== "") {
      writer.uint32(26).string(message.totpCode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LoginRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseLoginRequest } as LoginRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.email = reader.string();
          break;
        case 2:
          message.password = reader.string();
          break;
        case 3:
          message.totpCode = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): LoginRequest {
    const message = { ...baseLoginRequest } as LoginRequest;
    message.email =
      object.email !== undefined && object.email !== null
        ? String(object.email)
        : "";
    message.password =
      object.password !== undefined && object.password !== null
        ? String(object.password)
        : "";
    message.totpCode =
      object.totpCode !== undefined && object.totpCode !== null
        ? String(object.totpCode)
        : "";
    return message;
  },

  toJSON(message: LoginRequest): unknown {
    const obj: any = {};
    message.email !== undefined && (obj.email = message.email);
    message.password !== undefined && (obj.password = message.password);
    message.totpCode !== undefined && (obj.totpCode = message.totpCode);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<LoginRequest>, I>>(
    object: I
  ): LoginRequest {
    const message = { ...baseLoginRequest } as LoginRequest;
    message.email = object.email ?? "";
    message.password = object.password ?? "";
    message.totpCode = object.totpCode ?? "";
    return message;
  },
};

const baseLoginResponse: object = { token: "" };

export const LoginResponse = {
  encode(
    message: LoginResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(10).fork()).ldelim();
    }
    if (message.token !== "") {
      writer.uint32(18).string(message.token);
    }
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LoginResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseLoginResponse } as LoginResponse;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.error = Error.decode(reader, reader.uint32());
          break;
        case 2:
          message.token = reader.string();
          break;
        case 3:
          message.user = User.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): LoginResponse {
    const message = { ...baseLoginResponse } as LoginResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromJSON(object.error)
        : undefined;
    message.token =
      object.token !== undefined && object.token !== null
        ? String(object.token)
        : "";
    message.user =
      object.user !== undefined && object.user !== null
        ? User.fromJSON(object.user)
        : undefined;
    return message;
  },

  toJSON(message: LoginResponse): unknown {
    const obj: any = {};
    message.error !== undefined &&
      (obj.error = message.error ? Error.toJSON(message.error) : undefined);
    message.token !== undefined && (obj.token = message.token);
    message.user !== undefined &&
      (obj.user = message.user ? User.toJSON(message.user) : undefined);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<LoginResponse>, I>>(
    object: I
  ): LoginResponse {
    const message = { ...baseLoginResponse } as LoginResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromPartial(object.error)
        : undefined;
    message.token = object.token ?? "";
    message.user =
      object.user !== undefined && object.user !== null
        ? User.fromPartial(object.user)
        : undefined;
    return message;
  },
};

const baseVerificationRequest: object = { token: "" };

export const VerificationRequest = {
  encode(
    message: VerificationRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VerificationRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseVerificationRequest } as VerificationRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.token = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): VerificationRequest {
    const message = { ...baseVerificationRequest } as VerificationRequest;
    message.token =
      object.token !== undefined && object.token !== null
        ? String(object.token)
        : "";
    return message;
  },

  toJSON(message: VerificationRequest): unknown {
    const obj: any = {};
    message.token !== undefined && (obj.token = message.token);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<VerificationRequest>, I>>(
    object: I
  ): VerificationRequest {
    const message = { ...baseVerificationRequest } as VerificationRequest;
    message.token = object.token ?? "";
    return message;
  },
};

const basePasswordResetRequest: object = {
  email: "",
  token: "",
  newPassword: "",
};

export const PasswordResetRequest = {
  encode(
    message: PasswordResetRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    if (message.token !== "") {
      writer.uint32(18).string(message.token);
    }
    if (message.newPassword !== "") {
      writer.uint32(26).string(message.newPassword);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): PasswordResetRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...basePasswordResetRequest } as PasswordResetRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.email = reader.string();
          break;
        case 2:
          message.token = reader.string();
          break;
        case 3:
          message.newPassword = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): PasswordResetRequest {
    const message = { ...basePasswordResetRequest } as PasswordResetRequest;
    message.email =
      object.email !== undefined && object.email !== null
        ? String(object.email)
        : "";
    message.token =
      object.token !== undefined && object.token !== null
        ? String(object.token)
        : "";
    message.newPassword =
      object.newPassword !== undefined && object.newPassword !== null
        ? String(object.newPassword)
        : "";
    return message;
  },

  toJSON(message: PasswordResetRequest): unknown {
    const obj: any = {};
    message.email !== undefined && (obj.email = message.email);
    message.token !== undefined && (obj.token = message.token);
    message.newPassword !== undefined &&
      (obj.newPassword = message.newPassword);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<PasswordResetRequest>, I>>(
    object: I
  ): PasswordResetRequest {
    const message = { ...basePasswordResetRequest } as PasswordResetRequest;
    message.email = object.email ?? "";
    message.token = object.token ?? "";
    message.newPassword = object.newPassword ?? "";
    return message;
  },
};

const baseCompleteUserRegistrationRequest: object = {
  inviteToken: "",
  password: "",
};

export const CompleteUserRegistrationRequest = {
  encode(
    message: CompleteUserRegistrationRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.inviteToken !== "") {
      writer.uint32(10).string(message.inviteToken);
    }
    if (message.newUser !== undefined) {
      User.encode(message.newUser, writer.uint32(18).fork()).ldelim();
    }
    if (message.password !== "") {
      writer.uint32(26).string(message.password);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): CompleteUserRegistrationRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseCompleteUserRegistrationRequest,
    } as CompleteUserRegistrationRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.inviteToken = reader.string();
          break;
        case 2:
          message.newUser = User.decode(reader, reader.uint32());
          break;
        case 3:
          message.password = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): CompleteUserRegistrationRequest {
    const message = {
      ...baseCompleteUserRegistrationRequest,
    } as CompleteUserRegistrationRequest;
    message.inviteToken =
      object.inviteToken !== undefined && object.inviteToken !== null
        ? String(object.inviteToken)
        : "";
    message.newUser =
      object.newUser !== undefined && object.newUser !== null
        ? User.fromJSON(object.newUser)
        : undefined;
    message.password =
      object.password !== undefined && object.password !== null
        ? String(object.password)
        : "";
    return message;
  },

  toJSON(message: CompleteUserRegistrationRequest): unknown {
    const obj: any = {};
    message.inviteToken !== undefined &&
      (obj.inviteToken = message.inviteToken);
    message.newUser !== undefined &&
      (obj.newUser = message.newUser
        ? User.toJSON(message.newUser)
        : undefined);
    message.password !== undefined && (obj.password = message.password);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<CompleteUserRegistrationRequest>, I>>(
    object: I
  ): CompleteUserRegistrationRequest {
    const message = {
      ...baseCompleteUserRegistrationRequest,
    } as CompleteUserRegistrationRequest;
    message.inviteToken = object.inviteToken ?? "";
    message.newUser =
      object.newUser !== undefined && object.newUser !== null
        ? User.fromPartial(object.newUser)
        : undefined;
    message.password = object.password ?? "";
    return message;
  },
};

const baseInviteTesterRequest: object = { token: "", email: "" };

export const InviteTesterRequest = {
  encode(
    message: InviteTesterRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    if (message.email !== "") {
      writer.uint32(18).string(message.email);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InviteTesterRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseInviteTesterRequest } as InviteTesterRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.token = reader.string();
          break;
        case 2:
          message.email = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): InviteTesterRequest {
    const message = { ...baseInviteTesterRequest } as InviteTesterRequest;
    message.token =
      object.token !== undefined && object.token !== null
        ? String(object.token)
        : "";
    message.email =
      object.email !== undefined && object.email !== null
        ? String(object.email)
        : "";
    return message;
  },

  toJSON(message: InviteTesterRequest): unknown {
    const obj: any = {};
    message.token !== undefined && (obj.token = message.token);
    message.email !== undefined && (obj.email = message.email);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<InviteTesterRequest>, I>>(
    object: I
  ): InviteTesterRequest {
    const message = { ...baseInviteTesterRequest } as InviteTesterRequest;
    message.token = object.token ?? "";
    message.email = object.email ?? "";
    return message;
  },
};

export interface AuthService {
  Login(request: LoginRequest): Promise<LoginResponse>;
  IntakeNewAccount(request: IntakeRequest): Promise<ErrorResponse>;
  VerifyEmail(request: VerificationRequest): Promise<ErrorResponse>;
  ResendVerification(request: VerificationRequest): Promise<ErrorResponse>;
  StartPasswordReset(request: PasswordResetRequest): Promise<ErrorResponse>;
  CompletePasswordReset(request: PasswordResetRequest): Promise<ErrorResponse>;
  InviteTester(request: InviteTesterRequest): Promise<ErrorResponse>;
  CompleteUserRegistration(
    request: CompleteUserRegistrationRequest
  ): Promise<ErrorResponse>;
  StartRegistrationTOTP(
    request: TOTPRegistrationRequest
  ): Promise<TOTPRegistrationResponse>;
  CompleteRegistrationTOTP(request: TOTPRequest): Promise<ErrorResponse>;
}

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<
        Exclude<keyof I, KeysOfUnion<P>>,
        never
      >;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}
